import { accountContract } from "@common/contracts/account.contract";
import {
    AccountClass,
    AccountSubtype,
} from "@common/constants/domains/accounting/accounts";
import {
    AccountRolePresence,
    AccountRulePresence,
    AccountSource,
    AccountStatus,
} from "@common/types/domains/accounting/account";
import { Form1099BoxFilterValue } from "@common/constants/domains/accounting/form1099Box";
import { ChartOfAccountsColumn } from "@common/types/views/chartOfAccountsView";
import { CSV_MIME, XLSX_MIME } from "./fileDownload";
import { getBackendAPIClient } from "./backendAPIClient";

const accountContractBlobClient = getBackendAPIClient(accountContract, "blob");

export interface ChartOfAccountsExportParams {
    entityIds: number[];
    availableClassifications?: AccountClass[];
    accountStatus?: AccountStatus;
    accountSource?: AccountSource;
    accountRolePresence?: AccountRolePresence;
    accountRulePresence?: AccountRulePresence;
    accountSubtypes?: AccountSubtype[];
    form1099Boxes?: Form1099BoxFilterValue[];
    search?: string;
    coaTemplateGroupKeys?: string[];
    columns?: ChartOfAccountsColumn[];
}

export async function getChartOfAccountsCsv(
    params: ChartOfAccountsExportParams,
) {
    const response = await accountContractBlobClient.exportChartOfAccountsCsv({
        query: params,
        extraHeaders: {
            Accept: CSV_MIME,
        },
    });
    return response;
}

export async function getChartOfAccountsXlsx(
    params: ChartOfAccountsExportParams,
) {
    const response = await accountContractBlobClient.exportChartOfAccountsXlsx({
        query: params,
        extraHeaders: {
            Accept: XLSX_MIME,
        },
    });
    return response;
}
